export type RequiredElectronic = {
  ELECTRONIC_TYPE: string;
};

/** Groups required electronics by type so duplicate entries (e.g. two high-speed motors) render once with a count. */
export function countRequiredElectronicsByType(electronics: readonly RequiredElectronic[]): Record<string, number> {
  return electronics.reduce<Record<string, number>>((acc, electronic) => {
    const type = electronic.ELECTRONIC_TYPE;
    acc[type] = (acc[type] ?? 0) + 1;
    return acc;
  }, {});
}
